import { Link as RouterLink } from "react-router-dom"
import { Link } from "@mui/material"
const BaseLink = ({ path, children }) => {
  return (
    <Link component={RouterLink} to={path} sx={{ my: 2, cursor: "pointer" }}>
      {children}
    </Link>
  )
}

export default BaseLink
